/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <div className='footer-container'>
      <section className='social-media'>
        <div className='social-icons'>
          <a
            className='footer-social-icon-link facebook'
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.facebook.com/p/Northwoods-Handy-61592117862818/"
            aria-label="Northwoods Handy on Facebook"
          >
            <i className='fab fa-facebook-f' />
          </a>
          <a
            className='footer-social-icon-link instagram'
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.instagram.com/northwoods_handy/"
            aria-label="Northwoods Handy on Instagram"
          >
            <i className='fab fa-instagram' />
          </a>
        </div>
        <div className='copyrights-label'>
            <small className="copyrights">
            ©2023 Northwoodshandy. All Rights Reserved |
            <a
              className="website-dev"
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.eugenioespinoza.com"
            > Website by <img src={'https://eugenioespinoza.com/portfolio/assets/Eugenio_EspinozaLogo_hover.png'} alt="Eugenio E. Logo" />
            </a>
            {' | '}
            {/* Quiet entry point to the owner/webmaster portal. */}
            <a className="portal-link" href="/portal">Portal</a>
          </small>
        </div>
      </section>
    </div>
  );
}

export default Footer;